import React, { useEffect, useState } from "react";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

const ToothPositionView = ({ toothGridData }) => {
  const IsIndexSelected = (value) => {
    return (
      toothGridData?.find((item) => item.index == parseInt(value)) !== undefined
    );
  };

  const IsLinkedIndexSelected = (index, nextIndex) => {
    const currentItem = toothGridData?.find(
      (item) => item.index == parseInt(index)
    );
    const nextItem = toothGridData?.find(
      (item) => item.index == parseInt(nextIndex)
    );

    if (currentItem && nextItem) {
      return currentItem.isLink;
    }
    return false;
  };

  return (
    <div className="pointer-events-none">
      <div className="mt-5">
        <div className="flex items-center">
          <ToggleButtonGroup className="tooth_position_view">
            <div>
              {/* use this css for diable section : pointer-events-none */}
              <div className="flex items-center justify-between gap-4">
                <div className="flex items-center font-interRegular">
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-base text-center mb-2">18</p>
                    <ToggleButton
                      value="18"
                      selected={IsIndexSelected(18)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 18)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <ToggleButton
                      value="dot1"
                      className="!p-0 !rounded-full w-[9px] h-[9px] !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] bottom-2"
                      selected={IsLinkedIndexSelected(18, 17)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-base text-center mb-2">17</p>
                    <ToggleButton
                      value="17"
                      selected={IsIndexSelected(17)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 17)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <ToggleButton
                      value="dot2"
                      className="!p-0 !rounded-full w-[10px] h-[10px] !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] bottom-2"
                      selected={IsLinkedIndexSelected(17, 16)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-base text-center mb-2">16</p>
                    <ToggleButton
                      value="16"
                      selected={IsIndexSelected(16)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 16)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <ToggleButton
                      value="dot3"
                      className="!p-0 !rounded-full w-[10px] h-[10px] !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] bottom-2"
                      selected={IsLinkedIndexSelected(16, 15)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-base text-center mb-2">15</p>
                    <ToggleButton
                      value="15"
                      selected={IsIndexSelected(15)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 15)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <ToggleButton
                      value="dot4"
                      className="!p-0 !rounded-full w-[10px] h-[10px] !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] bottom-2"
                      selected={IsLinkedIndexSelected(15, 14)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-base text-center mb-2">14</p>
                    <ToggleButton
                      value="14"
                      selected={IsIndexSelected(14)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 14)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <ToggleButton
                      value="dot5"
                      className="!p-0 !rounded-full w-[10px] h-[10px] !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] bottom-2"
                      selected={IsLinkedIndexSelected(14, 13)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-base text-center mb-2">13</p>
                    <ToggleButton
                      value="13"
                      selected={IsIndexSelected(13)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 13)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <ToggleButton
                      value="dot6"
                      className="!p-0 !rounded-full w-[10px] h-[10px] !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] bottom-2"
                      selected={IsLinkedIndexSelected(13, 12)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-base text-center mb-2">12</p>
                    <ToggleButton
                      value="12"
                      selected={IsIndexSelected(12)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 12)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <ToggleButton
                      value="dot7"
                      className="!p-0 !rounded-full w-[10px] h-[10px] !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] bottom-2"
                      selected={IsLinkedIndexSelected(12, 11)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-base text-center mb-2">11</p>
                    <ToggleButton
                      value="11"
                      selected={IsIndexSelected(11)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 11)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                  </div>
                </div>
                <div className="flex items-center font-interRegular">
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-base text-center mb-2">21</p>
                    <ToggleButton
                      value="21"
                      selected={IsIndexSelected(21)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 21)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <ToggleButton
                      value="dot8"
                      className="!p-0 !rounded-full w-[10px] h-[10px] !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] bottom-2"
                      selected={IsLinkedIndexSelected(21, 22)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-base text-center mb-2">22</p>
                    <ToggleButton
                      value="22"
                      selected={IsIndexSelected(22)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 22)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <ToggleButton
                      value="dot9"
                      className="!p-0 !rounded-full  w-[10px] h-[10px] !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] bottom-2"
                      selected={IsLinkedIndexSelected(22, 23)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-base text-center mb-2">23</p>
                    <ToggleButton
                      value="23"
                      selected={IsIndexSelected(23)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 23)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <ToggleButton
                      value="dot10"
                      className="!p-0 !rounded-full  w-[10px] h-[10px] !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] bottom-2"
                      selected={IsLinkedIndexSelected(23, 24)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-base text-center mb-2">24</p>
                    <ToggleButton
                      value="24"
                      selected={IsIndexSelected(24)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 24)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <ToggleButton
                      value="dot11"
                      className="!p-0 !rounded-full  w-[10px] h-[10px] !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] bottom-2"
                      selected={IsLinkedIndexSelected(24, 25)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-base text-center mb-2">25</p>
                    <ToggleButton
                      value="25"
                      selected={IsIndexSelected(25)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 25)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <ToggleButton
                      value="dot12"
                      className="!p-0 !rounded-full  w-[10px] h-[10px] !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] bottom-2"
                      selected={IsLinkedIndexSelected(25, 26)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-base text-center mb-2">26</p>
                    <ToggleButton
                      value="26"
                      selected={IsIndexSelected(26)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 26)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <ToggleButton
                      value="dot13"
                      className="!p-0 !rounded-full  w-[10px] h-[10px] !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] bottom-2"
                      selected={IsLinkedIndexSelected(26, 27)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-base text-center mb-2">27</p>
                    <ToggleButton
                      value="27"
                      selected={IsIndexSelected(27)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 27)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <ToggleButton
                      value="dot14"
                      className="!p-0 !rounded-full  w-[10px] h-[10px] !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] bottom-2"
                      selected={IsLinkedIndexSelected(27, 28)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-base text-center mb-2">28</p>
                    <ToggleButton
                      value="28"
                      selected={IsIndexSelected(28)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 28)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                  </div>
                </div>
              </div>
              {/* use this css for diable section : pointer-events-none */}
              <div className="flex items-center justify-between gap-4 mt-5">
                <div className="flex items-center font-interRegular">
                  <div className="relative pr-1">
                    <ToggleButton
                      value="48"
                      selected={IsIndexSelected(48)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 48)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <p className="text-gray-600 text-base text-center">48</p>
                    <ToggleButton
                      value="dot22"
                      className="!p-0 !rounded-full w-[10px] h-[10px] !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] top-[10px]"
                      selected={IsLinkedIndexSelected(48, 47)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="47"
                      selected={IsIndexSelected(47)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 47)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <p className="text-gray-600 text-base text-center">47</p>
                    <ToggleButton
                      value="dot23"
                      className="!p-0 !rounded-full  w-[10px] h-[10px] !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] top-[10px]"
                      selected={IsLinkedIndexSelected(47, 46)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="46"
                      selected={IsIndexSelected(46)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 46)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <p className="text-gray-600 text-base text-center">46</p>
                    <ToggleButton
                      value="dot24"
                      className="!p-0 !rounded-full  w-[10px] h-[10px] !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] top-[10px]"
                      selected={IsLinkedIndexSelected(46, 45)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="45"
                      selected={IsIndexSelected(45)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 45)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <p className="text-gray-600 text-base text-center">45</p>
                    <ToggleButton
                      value="dot25"
                      className="!p-0 !rounded-full   w-[9px] h-[9px] !border !bg-white !absolute !border-gray-500 -right-[2px] z-[1] top-[10px]"
                      selected={IsLinkedIndexSelected(45, 46)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="44"
                      selected={IsIndexSelected(44)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 44)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <p className="text-gray-600 text-base text-center">44</p>
                    <ToggleButton
                      value="dot26"
                      className="!p-0 !rounded-full  w-[10px] h-[10px] !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] top-[10px]"
                      selected={IsLinkedIndexSelected(44, 43)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="43"
                      selected={IsIndexSelected(43)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 43)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <p className="text-gray-600 text-base text-center">43</p>
                    <ToggleButton
                      value="dot27"
                      className="!p-0 !rounded-full   w-[9px] h-[9px] !bg-white  !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] top-[10px]"
                      selected={IsLinkedIndexSelected(43, 42)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="42"
                      selected={IsIndexSelected(42)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 42)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <p className="text-gray-600 text-base text-center">42</p>
                    <ToggleButton
                      value="dot28"
                      className="!p-0 !rounded-full  w-[10px] h-[10px] !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] top-[10px]"
                      selected={IsLinkedIndexSelected(42, 41)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="41"
                      selected={IsIndexSelected(41)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 41)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <p className="text-gray-600 text-base text-center">41</p>
                  </div>
                </div>
                <div className="flex items-center  font-interRegular">
                  <div className="relative pr-1">
                    <ToggleButton
                      value="31"
                      selected={IsIndexSelected(31)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 31)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <p className="text-gray-600 text-base text-center">31</p>
                    <ToggleButton
                      value="dot15"
                      className="!p-0 !rounded-full w-[10px] h-[10px] !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] top-[10px]"
                      selected={IsLinkedIndexSelected(31, 32)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="32"
                      selected={IsIndexSelected(32)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 32)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <p className="text-gray-600 text-base text-center">32</p>
                    <ToggleButton
                      value="dot16"
                      className="!p-0 !rounded-full  w-[10px] h-[10px] !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] top-[10px]"
                      selected={IsLinkedIndexSelected(32, 33)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="33"
                      selected={IsIndexSelected(33)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 33)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <p className="text-gray-600 text-base text-center">33</p>
                    <ToggleButton
                      value="dot17"
                      className="!p-0 !rounded-full  w-[10px] h-[10px] !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] top-[10px]"
                      selected={IsLinkedIndexSelected(33, 34)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="34"
                      selected={IsIndexSelected(34)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 34)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <p className="text-gray-600 text-base text-center">34</p>
                    <ToggleButton
                      value="dot18"
                      className="!p-0 !rounded-full  w-[10px] h-[10px] !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] top-[10px]"
                      selected={IsLinkedIndexSelected(34, 35)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="35"
                      selected={IsIndexSelected(35)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 35)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <p className="text-gray-600 text-base text-center">35</p>
                    <ToggleButton
                      value="dot19"
                      className="!p-0 !rounded-full  w-[10px] h-[10px] !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] top-[10px]"
                      selected={IsLinkedIndexSelected(35, 36)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="36"
                      selected={IsIndexSelected(36)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 36)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <p className="text-gray-600 text-base text-center">36</p>
                    <ToggleButton
                      value="dot20"
                      className="!p-0 !rounded-full  w-[10px] h-[10px] !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] top-[10px]"
                      selected={IsLinkedIndexSelected(36, 37)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="37"
                      selected={IsIndexSelected(37)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 37)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <p className="text-gray-600 text-base text-center">37</p>
                    <ToggleButton
                      value="dot21"
                      className="!p-0 !rounded-full  w-[10px] h-[10px] !bg-white !border !absolute !border-gray-500 -right-[2px] z-[1] top-[10px]"
                      selected={IsLinkedIndexSelected(37, 38)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="38"
                      selected={IsIndexSelected(38)}
                      className="!p-0 !rounded-full w-7 h-7 !text-[9px] !text-transparent !border !border-gray-500 button_view flex items-center justify-center relative"
                    >
                      <span className="absolute top-[25%] transform -translate-y-1/2 text-base">
                        {
                          toothGridData?.find((item) => item.index == 38)
                            ?.gridLetter
                        }
                      </span>
                    </ToggleButton>
                    <p className="text-gray-600 text-base text-center">38</p>
                  </div>
                </div>
              </div>
            </div>
          </ToggleButtonGroup>
        </div>
      </div>
    </div>
  );
};

export default ToothPositionView;
